<template>
  <div class="StatusBadge">

    <p class="StatusBadge-label">
      Ask staff<br> for more info
    </p>

    <div class="StatusBadge-background"></div>

  </div>
</template>

<script>
export default {
  name: 'StatusBadge'
}
</script>

<style>
.StatusBadge {
  display: flex;
  align-items: center;
  justify-content: center;
}

.StatusBadge-label {
  position: relative;
  z-index: 1;
  color: var(--color-1);
}

.StatusBadge-background {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--color-4);
  border-radius: 50%;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// StatusBadge.vue?92533ab6